// ============================================================
// SITE CONFIG — ye file batati hai ke ye build kaunsi site hai.
//
// - KOT main site:        entitySlug = null
// - Company site copy me: generator script entitySlug set kar deta hai
//   (e.g. "digital-systems") — phir "/" par us company ka home render
//   hota hai aur navigation us company ki apni hoti hai.
//
// KOT main site ka live URL (company sites ke "KOT Group" link ke liye):
// ============================================================

export const KOT_MAIN_URL = "https://kotenterprises.com";

export const siteConfig: { entitySlug: string | null } = {
  entitySlug: "commerce-x",
};
